<template>
  <div>
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >新增</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      :edit-rules="rules"
      :edit-config="canEdit ? { trigger: 'click', mode: 'row' } : ''"
      :valid-config="{ autoPos: true, message: 'inline' }"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import API from '@/api/capitalCenter/receivablesManage';
  export default {
    name: 'detailInfo',
    props: ['canEdit'],
    components: {
      // inputNumberAd,
    },
    computed: {
      column() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 序号
            type: 'seq',
            width: 60,
            title: this.$t('table.index'),
          },
          {
            field: 'interestEffectiveStartDays',
            title: this.$t('sbRateConfig.column.interestEffectiveStartDays'), // 利率期限起始天数
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.interestEffectiveStartDays,
                      this.$globalVar.dPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.interestEffectiveStartDays}
                    max={99999999999}
                    min={0}
                    precision={this.$globalVar.dPoint}
                    onInput={(val) => this.chooseTable(val, row, 'interestEffectiveStartDays')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'interestEffectiveEndDays',
            title: this.$t('sbRateConfig.column.interestEffectiveEndDays'), // 利率期限到期天数
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.interestEffectiveEndDays,
                      this.$globalVar.dPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.interestEffectiveEndDays}
                    max={99999999999}
                    min={0}
                    precision={this.$globalVar.dPoint}
                    onInput={(val) => this.chooseTable(val, row, 'interestEffectiveEndDays')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'interestRate',
            title: this.$t('sbRateConfig.column.interestRate'), // 利率
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.interestRate, this.$globalVar.iPoint)}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.interestRate}
                    max={99999999999.99}
                    min={0}
                    precision={this.$globalVar.iPoint}
                    onInput={(val) => this.chooseTable(val, row, 'interestRate')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'remark',
            title: this.$t('sbRateConfig.column.remark'), // 备注
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
    },
    data() {
      return {
        tableData: [],
        addRowObj: {
          interestEffectiveStartDays: null,
          interestEffectiveEndDays: null,
          interestRate: null,
          remark: null,
        },
        rules: {
          interestEffectiveStartDays: [
            {
              required: true,
              message: this.$t('sbRateConfig.placeholder.interestEffectiveStartDays'),
              trigger: ['blur', 'change'],
            },
          ],
          interestRate: [
            {
              required: true,
              message: this.$t('sbRateConfig.placeholder.interestRate'),
              trigger: ['blur', 'change'],
            },
          ],
        },
      };
    },
    methods: {
      insertEvent(row) {
        // 表格新增一行
        this.$refs.table.validate().then(() => {
          this.$refs.table.insertAt({ ...this.addRowObj }, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      handleDelete() {
        // 表格删除
        const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: this.$t('message.cancelled') });
          });
      },
      updateData(tableName) {
        // 在值发生改变时更新数据
        let xTable = this.$refs[tableName];
        xTable.updateData();
      },
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      exportChildData() {
        // 返回数据
        const [...tableData] = this.$refs.table.getTableData().fullData;
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
    },
  };
</script>
